import { motion } from "framer-motion";
import { MaskedLines } from "@/components/Reveal";

const STEPS = [
  { n: "01", t: "Choose or enquire", d: "Pick a plan and subscribe online in minutes, or send a quick enquiry for a bespoke proposal." },
  { n: "02", t: "Visit & tasting", d: "We visit your site, meet your team and cook a tasting menu around your people." },
  { n: "03", t: "Mobilise", d: "We set up the kitchen, staff, suppliers and records, with a clear start date." },
  { n: "04", t: "Serve & improve", d: "Regular reviews, feedback and menu refreshes keep standards high." },
];

export const Process = () => (
  <section className="bg-[#EFEAE1] py-24 sm:py-32" data-testid="process-section">
    <div className="mx-auto grid max-w-[1400px] gap-14 px-5 sm:px-8 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <p className="eyebrow text-[#9a7614]">How it works</p>
          <MaskedLines lines={["From first call", "to first plate."]} italic={1} className="mt-4 font-display text-4xl font-bold leading-[1.02] tracking-tight sm:text-6xl" />
          <p className="mt-6 max-w-md text-stone-700">A simple, transparent route to a catering contract, with one point of contact throughout.</p>
        </div>
      </div>
      <div className="lg:col-span-7">
        {STEPS.map((s, i) => (
          <motion.div
            key={s.n}
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay: i * 0.05, ease: [0.22, 1, 0.36, 1] }}
            className="group grid grid-cols-[auto,1fr] gap-6 border-t border-stone-400/50 py-10 sm:gap-10"
            data-testid={`process-step-${s.n}`}
          >
            <span className="font-display text-5xl italic text-[#C59B27] transition-transform duration-500 group-hover:-translate-y-1 sm:text-7xl">{s.n}</span>
            <div>
              <h3 className="font-display text-2xl font-semibold sm:text-3xl">{s.t}</h3>
              <p className="mt-3 max-w-lg text-stone-700">{s.d}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
